module.exports = __webpack_public_path__ + "static/media/card-ai-agent-mobile-br.a03921df.png";